// components/ResearchSkeleton.jsx
const ResearchSkeleton = ({ isDarkMode }) => {
  const tone = isDarkMode ? 'bg-slate-700' : 'bg-gray-200';

  return (
    <div
      className={`flex flex-col px-6 py-8 mx-auto w-full h-full overflow-y-auto ${
        isDarkMode ? 'bg-gray-900 text-slate-100' : 'bg-white text-dark'
      }`}
    >
      {/* HEADER SKELETON */}
      <div className="mb-10 text-center animate-pulse">
        <div className={`h-7 w-64 mx-auto rounded ${tone}`} />
        <div className={`h-4 w-96 mx-auto rounded mt-4 ${tone}`} />
        <div className={`h-4 w-64 mx-auto rounded mt-4 ${tone}`} />
      </div>

      {/* GRID SKELETONS */}
      <div className="grid gap-6 w-full max-w-6xl mx-auto grid-cols-1 sm:grid-cols-2 xl:grid-cols-3">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className={`animate-pulse border rounded-2xl p-6 w-full h-[350px] flex flex-col justify-between ${
              isDarkMode
                ? 'border-slate-700 bg-slate-800'
                : 'border-brandLighter bg-white'
            }`}
          >
            {/* Title */}
            <div className="space-y-3">
              <div className={`h-4 w-3/4 rounded ${tone}`} />
              <div className={`h-4 w-1/2 rounded ${tone}`} />
            </div>

            {/* Preview */}
            <div className="space-y-2 mt-6">
              {[1, 2, 3, 4].map((line) => (
                <div key={line} className={`h-3 w-full rounded ${tone}`} />
              ))}
            </div>

            {/* Date Rows */}
            <div className="space-y-2 mt-6">
              <div className={`h-3 w-1/3 rounded ${tone}`} />
              <div className={`h-3 w-1/4 rounded ${tone}`} />
            </div>

            {/* Button */}
            <div className={`h-10 w-full rounded-lg mt-4 ${tone}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResearchSkeleton;
